// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Header from "../Header";
// import { Table, Input } from "antd";
// import { FetchUserDetailsForAdmin, UpdateUserDetails } from "../../api/aws-api";
// import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
// import { ClassicSpinner } from "react-spinners-kit";
// import Swal from "sweetalert2";

// const UserManagement = () => {
//   const [loading, setLoading] = useState(false);
//   const [searchValue, setSearchValue] = useState("");
//   const [userdata, setUserData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [selecteduser, setSelectedUser] = useState(null);

//   const [userName, setUserName] = useState("");
//   const [userType, setUserType] = useState("");
//   const [email, setEmail] = useState("");
//   const [phone, setPhone] = useState("");
//   const [status, setStatus] = useState("");

//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchdata();
//   }, []);

//   // ================= SweetAlert styles =================
//   const swalStyles = `
// .swal2-popup { font-size: 16px !important; }
// .swal2-title { font-weight: 600 !important; }
// .swal2-confirm { background-color: #000 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// .swal2-cancel { background-color: #dc2626 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// `;
//   if (typeof document !== "undefined") {
//     const style = document.createElement("style");
//     style.innerHTML = swalStyles;
//     document.head.appendChild(style);
//   }

//   // ================= FETCH USERS =================
//   const fetchdata = async () => {
//     try {
//       setLoading(true);
//       const response = await ConstructorEventGet(FetchUserDetailsForAdmin);
//       let users = [];
//       if (response?.body) {
//         let parsed = response.body;
//         if (typeof parsed === "string") parsed = JSON.parse(parsed);
//         if (typeof parsed === "string") parsed = JSON.parse(parsed);
//         users = parsed;
//       } else if (Array.isArray(response)) {
//         users = response;
//       }
//       setUserData(users);
//       setFilteredData(users);
//     } catch (error) {
//       console.error(error);
//       Swal.fire("Error", "Failed to fetch users", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetState = () => {
//     setSelectedUser(null);
//     setUserName("");
//     setUserType("");
//     setEmail("");
//     setPhone("");
//     setStatus("");
//   };

//   const setUser = (data) => {
//     setSelectedUser(data);
//     setUserName(data.name);
//     setUserType(data.type);
//     setEmail(data.email);
//     setPhone(data.mobile);
//     setStatus(data.status);
//   };

//   // ================= UPDATE USER =================
//   const UpdateUserDataToCloud = async () => {
//     if (!selecteduser) return;
//     try {
//       setLoading(true);
//       const params = {
//         action: "update",
//         user_id: selecteduser.id,
//         user_type: userType,
//         user_mobile: phone,
//         user_status: status,
//         user_name: userName,
//         user_email: email,
//       };
//       const response = await ConstructorEventPost(UpdateUserDetails, params);
//       const result =
//         typeof response === "string"
//           ? response
//           : response?.body
//           ? JSON.parse(response.body)
//           : null;
//       if (result === "updated") {
//         Swal.fire({
//           title: "Success!",
//           text: "User updated successfully",
//           icon: "success",
//           confirmButtonText: "OK",
//           confirmButtonColor: "#000"
//         });

//         // ===== Update the user in both userdata and filteredData =====
//         const updatedUser = {
//           ...selecteduser,
//           name: userName,
//           type: userType,
//           email,
//           mobile: phone,
//           status,
//         };

//         const newUserData = userdata.map((u) =>
//           u.id === updatedUser.id ? updatedUser : u
//         );
//         setUserData(newUserData);

//         const newFilteredData = filteredData.map((u) =>
//           u.id === updatedUser.id ? updatedUser : u
//         );
//         setFilteredData(newFilteredData);

//         resetState();
//       } else {
//         throw new Error("Update failed");
//       }
//     } catch (error) {
//       Swal.fire("Error", "Failed to update user", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= DELETE USER =================
//   const deleteUser = async (record) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Delete user ${record.name}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Delete",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#dc2626",
//       cancelButtonColor: "#6b7280",
//       reverseButtons: true
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           setLoading(true);
//           const params = { action: "delete", user_id: record.id };
//           const response = await ConstructorEventPost(UpdateUserDetails, params);
//           const resultData =
//             typeof response === "string"
//               ? response
//               : response?.body
//               ? JSON.parse(response.body)
//               : null;
//           if (resultData === "deleted") {
//             Swal.fire("Deleted!", "User removed successfully.", "success");

//             // Remove from both arrays
//             const newUserData = userdata.filter((u) => u.id !== record.id);
//             setUserData(newUserData);
//             const newFilteredData = filteredData.filter((u) => u.id !== record.id);
//             setFilteredData(newFilteredData);

//             resetState();
//           } else {
//             throw new Error("Delete failed");
//           }
//         } catch (error) {
//           Swal.fire("Error", "Failed to delete user", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     });
//   };

//   // ================= SEARCH =================
//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchValue(value);
//     if (!value.trim()) {
//       setFilteredData(userdata);
//       return;
//     }
//     const filtered = userdata.filter(
//       (record) =>
//         record.name?.toLowerCase().includes(value) ||
//         record.email?.toLowerCase().includes(value) ||
//         record.mobile?.toLowerCase().includes(value)
//     );
//     setFilteredData(filtered);
//   };

//   // ================= TABLE COLUMNS =================
//   const columns = [
//     {
//       title: "Users",
//       dataIndex: "name",
//       render: (text, record) => <Link onClick={() => setUser(record)}>{text}</Link>,
//     },
//     { title: "User Type", dataIndex: "type" },
//     { title: "Email", dataIndex: "email" },
//     { title: "Phone", dataIndex: "mobile" },
//     { title: "Status", dataIndex: "status" },
//     { title: "Course", dataIndex: "course" },
//     {
//       title: "Actions",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: "6px" }}>
//           <button
//             style={{
//               padding: "3px 8px",
//               fontSize: "11px",
//               borderRadius: "4px",
//               border: "none",
//               backgroundColor: "#000",
//               color: "#fff",
//               cursor: "pointer",
//             }}
//             onClick={() => setUser(record)}
//           >
//             Edit
//           </button>
//           <button
//             style={{
//               padding: "3px 8px",
//               fontSize: "11px",
//               borderRadius: "4px",
//               border: "none",
//               backgroundColor: "#dc2626",
//               color: "#fff",
//               cursor: "pointer",
//             }}
//             onClick={() => deleteUser(record)}
//           >
//             Delete
//           </button>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <>
//       <Header />

//       {loading ? (
//         <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           <ClassicSpinner size={50} color="black" loading={loading} />
//         </div>
//       ) : (
//         <div className="section-padding">
//           <div className="container grid grid-cols-12 gap-6">
//             <div className="col-span-5">
//               <div className="mini-title">
//                 User Management
//                 <div
//                   className="small-btn ml-4"
//                   onClick={() => navigate("/codomo/admin/createnewuser")}
//                 >
//                   New User
//                 </div>
//               </div>

//               <div className="bg-white shadow-box7 p-8 rounded-md mt-6">
//                 <Input
//                   placeholder="Search by Name, Phone or Email"
//                   value={searchValue}
//                   onChange={handleSearch}
//                   style={{ marginBottom: 16 }}
//                 />

//                 {selecteduser && (
//                   <>
//                     <hr />
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       value={userName}
//                       onChange={(e) => setUserName(e.target.value)}
//                     />
//                     <select
//                       className="from-control mt-4"
//                       value={userType}
//                       onChange={(e) => setUserType(e.target.value)}
//                     >
//                       <option value="student">Student</option>
//                       <option value="mentor">Mentor</option>
//                       <option value="admin">Admin</option>
//                     </select>
//                     <input
//                       type="email"
//                       className="from-control mt-4"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       value={phone}
//                       onChange={(e) => setPhone(e.target.value)}
//                     />
//                     <select
//                       className="from-control mt-4"
//                       value={status}
//                       onChange={(e) => setStatus(e.target.value)}
//                     >
//                       <option value="active">Active</option>
//                       <option value="inactive">Inactive</option>
//                       <option value="expired">Expired</option>
//                     </select>
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       value={selecteduser?.course || "No Course Assigned"}
//                       disabled
//                     />
//                     <div className="flex gap-2 mt-4">
//                       <div>
//                         <button
//                           className="btn btn-black"
//                           onClick={UpdateUserDataToCloud}
//                         >
//                           Update User
//                         </button>
//                       </div>
//                       <div style={{ paddingLeft: "10px" }}>
//                         <button
//                           className="btn btn-red ms-2"
//                           onClick={resetState}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>

//             <div className="col-span-12">
//               <div className="bg-white shadow-box7 p-8 rounded-md">
//                 <div style={{ marginBottom: "10px" }}>
//                   User Count: {filteredData.length}
//                 </div>
//                 <Table
//                   columns={columns}
//                   dataSource={filteredData}
//                   rowKey={(record) => record.id}
//                   pagination={filteredData.length > 9}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserManagement;




































// // import React, { useState, useEffect } from "react";
// // import { useNavigate, Link } from "react-router-dom";
// // import Header from "../Header";
// // import { Table, Input } from "antd";
// // import { FetchUserDetailsForAdmin, UpdateUserDetails } from "../../api/aws-api";
// // import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
// // import { ClassicSpinner } from "react-spinners-kit";
// // import Swal from "sweetalert2";

// // const UserManagement = () => {
// //   const [loading, setLoading] = useState(false);
// //   const [searchValue, setSearchValue] = useState("");
// //   const [userdata, setUserData] = useState([]);
// //   const [filteredData, setFilteredData] = useState([]);
// //   const [selecteduser, setSelectedUser] = useState(null);

// //   const [userName, setUserName] = useState("");
// //   const [userType, setUserType] = useState("");
// //   const [email, setEmail] = useState("");
// //   const [phone, setPhone] = useState("");
// //   const [status, setStatus] = useState("");
// //   const [course, setCourse] = useState("");

// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     fetchdata();
// //   }, []);

// //   // ================= SweetAlert styles =================
// //   const swalStyles = `
// // .swal2-popup { font-size: 16px !important; }
// // .swal2-title { font-weight: 600 !important; }
// // .swal2-confirm { background-color: #000 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// // .swal2-cancel { background-color: #dc2626 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// // `;
// //   if (typeof document !== "undefined") {
// //     const style = document.createElement("style");
// //     style.innerHTML = swalStyles;
// //     document.head.appendChild(style);
// //   }

// //   // ================= FETCH USERS =================
// //   const fetchdata = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await ConstructorEventGet(FetchUserDetailsForAdmin);
// //       let users = [];
// //       if (response?.body) {
// //         let parsed = response.body;
// //         if (typeof parsed === "string") parsed = JSON.parse(parsed);
// //         if (typeof parsed === "string") parsed = JSON.parse(parsed);
// //         users = parsed;
// //       } else if (Array.isArray(response)) {
// //         users = response;
// //       }
// //       setUserData(users);
// //       setFilteredData(users);
// //     } catch (error) {
// //       console.error(error);
// //       Swal.fire("Error", "Failed to fetch users", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const resetState = () => {
// //     setSelectedUser(null);
// //     setUserName("");
// //     setUserType("");
// //     setEmail("");
// //     setPhone("");
// //     setStatus("");
// //     setCourse("");
// //   };

// //   const setUser = (data) => {
// //     setSelectedUser(data);
// //     setUserName(data.name);
// //     setUserType(data.type);
// //     setEmail(data.email);
// //     setPhone(data.mobile);
// //     setStatus(data.status);
// //     // "No Course Assigned" is a display placeholder from the backend, not
// //     // a real course name — don't let it round-trip back into the field.
// //     setCourse(data.course && data.course !== "No Course Assigned" ? data.course : "");
// //   };

// //   // ================= UPDATE USER =================
// //   const UpdateUserDataToCloud = async () => {
// //     if (!selecteduser) return;
// //     try {
// //       setLoading(true);
// //       const params = {
// //         action: "update",
// //         user_id: selecteduser.id,
// //         user_type: userType,
// //         user_mobile: phone,
// //         user_status: status,
// //         user_name: userName,
// //         user_email: email,
// //         // Comma-separated course names, e.g. "Junior Innovators, Foundation"
// //         // Backend turns this into the list-of-course-objects shape it stores.
// //         user_course: course,
// //       };
// //       const response = await ConstructorEventPost(UpdateUserDetails, params);
// //       const result =
// //         typeof response === "string"
// //           ? response
// //           : response?.body
// //           ? JSON.parse(response.body)
// //           : null;
// //       if (result === "updated") {
// //         Swal.fire({
// //           title: "Success!",
// //           text: "User updated successfully",
// //           icon: "success",
// //           confirmButtonText: "OK",
// //           confirmButtonColor: "#000"
// //         });

// //         // ===== Update the user in both userdata and filteredData =====
// //         const updatedUser = {
// //           ...selecteduser,
// //           name: userName,
// //           type: userType,
// //           email,
// //           mobile: phone,
// //           status,
// //           course: course.trim() ? course : "No Course Assigned",
// //         };

// //         const newUserData = userdata.map((u) =>
// //           u.id === updatedUser.id ? updatedUser : u
// //         );
// //         setUserData(newUserData);

// //         const newFilteredData = filteredData.map((u) =>
// //           u.id === updatedUser.id ? updatedUser : u
// //         );
// //         setFilteredData(newFilteredData);

// //         resetState();
// //       } else {
// //         throw new Error("Update failed");
// //       }
// //     } catch (error) {
// //       Swal.fire("Error", "Failed to update user", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // ================= DELETE USER =================
// //   const deleteUser = async (record) => {
// //     Swal.fire({
// //       title: "Are you sure?",
// //       text: `Delete user ${record.name}?`,
// //       icon: "warning",
// //       showCancelButton: true,
// //       confirmButtonText: "Yes, Delete",
// //       cancelButtonText: "Cancel",
// //       confirmButtonColor: "#dc2626",
// //       cancelButtonColor: "#6b7280",
// //       reverseButtons: true
// //     }).then(async (result) => {
// //       if (result.isConfirmed) {
// //         try {
// //           setLoading(true);
// //           const params = { action: "delete", user_id: record.id };
// //           const response = await ConstructorEventPost(UpdateUserDetails, params);
// //           const resultData =
// //             typeof response === "string"
// //               ? response
// //               : response?.body
// //               ? JSON.parse(response.body)
// //               : null;
// //           if (resultData === "deleted") {
// //             Swal.fire("Deleted!", "User removed successfully.", "success");

// //             // Remove from both arrays
// //             const newUserData = userdata.filter((u) => u.id !== record.id);
// //             setUserData(newUserData);
// //             const newFilteredData = filteredData.filter((u) => u.id !== record.id);
// //             setFilteredData(newFilteredData);

// //             resetState();
// //           } else {
// //             throw new Error("Delete failed");
// //           }
// //         } catch (error) {
// //           Swal.fire("Error", "Failed to delete user", "error");
// //         } finally {
// //           setLoading(false);
// //         }
// //       }
// //     });
// //   };

// //   // ================= SEARCH =================
// //   const handleSearch = (e) => {
// //     const value = e.target.value.toLowerCase();
// //     setSearchValue(value);
// //     if (!value.trim()) {
// //       setFilteredData(userdata);
// //       return;
// //     }
// //     const filtered = userdata.filter(
// //       (record) =>
// //         record.name?.toLowerCase().includes(value) ||
// //         record.email?.toLowerCase().includes(value) ||
// //         record.mobile?.toLowerCase().includes(value)
// //     );
// //     setFilteredData(filtered);
// //   };

// //   // ================= TABLE COLUMNS =================
// //   const columns = [
// //     {
// //       title: "Users",
// //       dataIndex: "name",
// //       render: (text, record) => <Link onClick={() => setUser(record)}>{text}</Link>,
// //     },
// //     { title: "User Type", dataIndex: "type" },
// //     { title: "Email", dataIndex: "email" },
// //     { title: "Phone", dataIndex: "mobile" },
// //     { title: "Status", dataIndex: "status" },
// //     { title: "Course", dataIndex: "course" },
// //     {
// //       title: "Actions",
// //       render: (_, record) => (
// //         <div style={{ display: "flex", gap: "6px" }}>
// //           <button
// //             style={{
// //               padding: "3px 8px",
// //               fontSize: "11px",
// //               borderRadius: "4px",
// //               border: "none",
// //               backgroundColor: "#000",
// //               color: "#fff",
// //               cursor: "pointer",
// //             }}
// //             onClick={() => setUser(record)}
// //           >
// //             Edit
// //           </button>
// //           <button
// //             style={{
// //               padding: "3px 8px",
// //               fontSize: "11px",
// //               borderRadius: "4px",
// //               border: "none",
// //               backgroundColor: "#dc2626",
// //               color: "#fff",
// //               cursor: "pointer",
// //             }}
// //             onClick={() => deleteUser(record)}
// //           >
// //             Delete
// //           </button>
// //         </div>
// //       ),
// //     },
// //   ];

// //   return (
// //     <>
// //       <Header />

// //       {loading ? (
// //         <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
// //           <ClassicSpinner size={50} color="black" loading={loading} />
// //         </div>
// //       ) : (
// //         <div className="section-padding">
// //           <div className="container grid grid-cols-12 gap-6">
// //             <div className="col-span-5">
// //               <div className="mini-title">
// //                 User Management
// //                 <div
// //                   className="small-btn ml-4"
// //                   onClick={() => navigate("/codomo/admin/createnewuser")}
// //                 >
// //                   New User
// //                 </div>
// //               </div>

// //               <div className="bg-white shadow-box7 p-8 rounded-md mt-6">
// //                 <Input
// //                   placeholder="Search by Name, Phone or Email"
// //                   value={searchValue}
// //                   onChange={handleSearch}
// //                   style={{ marginBottom: 16 }}
// //                 />

// //                 {selecteduser && (
// //                   <>
// //                     <hr />
// //                     <input
// //                       type="text"
// //                       className="from-control mt-4"
// //                       value={userName}
// //                       onChange={(e) => setUserName(e.target.value)}
// //                     />
// //                     <select
// //                       className="from-control mt-4"
// //                       value={userType}
// //                       onChange={(e) => setUserType(e.target.value)}
// //                     >
// //                       <option value="student">Student</option>
// //                       <option value="mentor">Mentor</option>
// //                       <option value="admin">Admin</option>
// //                     </select>
// //                     <input
// //                       type="email"
// //                       className="from-control mt-4"
// //                       value={email}
// //                       onChange={(e) => setEmail(e.target.value)}
// //                     />
// //                     <input
// //                       type="text"
// //                       className="from-control mt-4"
// //                       value={phone}
// //                       onChange={(e) => setPhone(e.target.value)}
// //                     />
// //                     <select
// //                       className="from-control mt-4"
// //                       value={status}
// //                       onChange={(e) => setStatus(e.target.value)}
// //                     >
// //                       <option value="active">Active</option>
// //                       <option value="inactive">Inactive</option>
// //                       <option value="expired">Expired</option>
// //                     </select>
// //                     <input
// //                       type="text"
// //                       className="from-control mt-4"
// //                       placeholder="No Course Assigned"
// //                       value={course}
// //                       onChange={(e) => setCourse(e.target.value)}
// //                     />
// //                     <div className="flex gap-2 mt-4">
// //                       <div>
// //                         <button
// //                           className="btn btn-black"
// //                           onClick={UpdateUserDataToCloud}
// //                         >
// //                           Update User
// //                         </button>
// //                       </div>
// //                       <div style={{ paddingLeft: "10px" }}>
// //                         <button
// //                           className="btn btn-red ms-2"
// //                           onClick={resetState}
// //                         >
// //                           Cancel
// //                         </button>
// //                       </div>
// //                     </div>
// //                   </>
// //                 )}
// //               </div>
// //             </div>

// //             <div className="col-span-12">
// //               <div className="bg-white shadow-box7 p-8 rounded-md">
// //                 <div style={{ marginBottom: "10px" }}>
// //                   User Count: {filteredData.length}
// //                 </div>
// //                 <Table
// //                   columns={columns}
// //                   dataSource={filteredData}
// //                   rowKey={(record) => record.id}
// //                   pagination={filteredData.length > 9}
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default UserManagement;


































// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Header from "../Header";
// import { Table, Input } from "antd";
// import { FetchUserDetailsForAdmin, UpdateUserDetails } from "../../api/aws-api";
// import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
// import { ClassicSpinner } from "react-spinners-kit";
// import Swal from "sweetalert2";

// const UserManagement = () => {
//   const [loading, setLoading] = useState(false);
//   const [searchValue, setSearchValue] = useState("");
//   const [userdata, setUserData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [selecteduser, setSelectedUser] = useState(null);

//   const [userName, setUserName] = useState("");
//   const [userType, setUserType] = useState("");
//   const [email, setEmail] = useState("");
//   const [phone, setPhone] = useState("");
//   const [status, setStatus] = useState("");
//   const [course, setCourse] = useState("");

//   const [meetLink, setMeetLink] = useState("");

  

//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchdata();
//   }, []);

//   // ================= SweetAlert styles =================
//   const swalStyles = `
// .swal2-popup { font-size: 16px !important; }
// .swal2-title { font-weight: 600 !important; }
// .swal2-confirm { background-color: #000 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// .swal2-cancel { background-color: #dc2626 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
// `;
//   if (typeof document !== "undefined") {
//     const style = document.createElement("style");
//     style.innerHTML = swalStyles;
//     document.head.appendChild(style);
//   }

//   // ================= FETCH USERS =================
//   const fetchdata = async () => {
//     try {
//       setLoading(true);
//       const response = await ConstructorEventGet(FetchUserDetailsForAdmin);
//       let users = [];
//       if (response?.body) {
//         let parsed = response.body;
//         if (typeof parsed === "string") parsed = JSON.parse(parsed);
//         if (typeof parsed === "string") parsed = JSON.parse(parsed);
//         users = parsed;
//       } else if (Array.isArray(response)) {
//         users = response;
//       }
//       setUserData(users);
//       setFilteredData(users);
//     } catch (error) {
//       console.error(error);
//       Swal.fire("Error", "Failed to fetch users", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const resetState = () => {
//   //   setSelectedUser(null);
//   //   setUserName("");
//   //   setUserType("");
//   //   setEmail("");
//   //   setPhone("");
//   //   setStatus("");
//   //   setCourse("");
//   // };


//   const resetState = () => {
//     setSelectedUser(null);
//     setUserName("");
//     setUserType("");
//     setEmail("");
//     setPhone("");
//     setStatus("");
//     setCourse("");
//     setMeetLink("");   // NEW
//   };

//   // const setUser = (data) => {
//   //   setSelectedUser(data);
//   //   setUserName(data.name);
//   //   setUserType(data.type);
//   //   setEmail(data.email);
//   //   setPhone(data.mobile);
//   //   setStatus(data.status);
//   //   // "No Course Assigned" is a display placeholder from the backend, not
//   //   // a real course name — don't let it round-trip back into the field.
//   //   setCourse(data.course && data.course !== "No Course Assigned" ? data.course : "");
//   // };

//     const setUser = (data) => {
//       setSelectedUser(data);
//       setUserName(data.name);
//       setUserType(data.type);
//       setEmail(data.email);
//       setPhone(data.mobile);
//       setStatus(data.status);
//       setCourse(data.course && data.course !== "No Course Assigned" ? data.course : "");
//       setMeetLink(data.meet_link || "");   // NEW
//     };

//   // ================= UPDATE USER =================
//   const UpdateUserDataToCloud = async () => {
//     if (!selecteduser) return;
//     try {
//       setLoading(true);
//       // const params = {
//       //   action: "update",
//       //   user_id: selecteduser.id,
//       //   user_type: userType,
//       //   user_mobile: phone,
//       //   user_status: status,
//       //   user_name: userName,
//       //   user_email: email,
//       //   // Comma-separated course names, e.g. "Junior Innovators, Foundation"
//       //   // Backend turns this into the list-of-course-objects shape it stores.
//       //   user_course: course,
//       // };

//       const params = {
//         action: "update",
//         user_id: selecteduser.id,
//         user_type: userType,
//         user_mobile: phone,
//         user_status: status,
//         user_name: userName,
//         user_email: email,
//         user_course: course,
//         user_meet_link: meetLink,   // NEW — backend writes this to meet_link on the item
//       };


//       const response = await ConstructorEventPost(UpdateUserDetails, params);

//       // The backend returns statusCode 409 with {error: "duplicate", message}
//       // when the email/mobile already belongs to a different account.
//       if (response?.statusCode === 409) {
//         const conflict = response?.body ? JSON.parse(response.body) : null;
//         Swal.fire("Can't update user", conflict?.message || "This email or mobile number is already in use.", "warning");
//         setLoading(false);
//         return;
//       }

//       const result =
//         typeof response === "string"
//           ? response
//           : response?.body
//           ? JSON.parse(response.body)
//           : null;
//       if (result === "updated") {
//         Swal.fire({
//           title: "Success!",
//           text: "User updated successfully",
//           icon: "success",
//           confirmButtonText: "OK",
//           confirmButtonColor: "#000"
//         });

//         // ===== Update the user in both userdata and filteredData =====
//         const updatedUser = {
//           ...selecteduser,
//           name: userName,
//           type: userType,
//           email,
//           mobile: phone,
//           status,
//           course: course.trim() ? course : "No Course Assigned",
//         };

//         const newUserData = userdata.map((u) =>
//           u.id === updatedUser.id ? updatedUser : u
//         );
//         setUserData(newUserData);

//         const newFilteredData = filteredData.map((u) =>
//           u.id === updatedUser.id ? updatedUser : u
//         );
//         setFilteredData(newFilteredData);

//         resetState();
//       } else {
//         throw new Error("Update failed");
//       }
//     } catch (error) {
//       Swal.fire("Error", "Failed to update user", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= DELETE USER =================
//   const deleteUser = async (record) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Delete user ${record.name}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Delete",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#dc2626",
//       cancelButtonColor: "#6b7280",
//       reverseButtons: true
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           setLoading(true);
//           const params = { action: "delete", user_id: record.id };
//           const response = await ConstructorEventPost(UpdateUserDetails, params);
//           const resultData =
//             typeof response === "string"
//               ? response
//               : response?.body
//               ? JSON.parse(response.body)
//               : null;
//           if (resultData === "deleted") {
//             Swal.fire("Deleted!", "User removed successfully.", "success");

//             // Remove from both arrays
//             const newUserData = userdata.filter((u) => u.id !== record.id);
//             setUserData(newUserData);
//             const newFilteredData = filteredData.filter((u) => u.id !== record.id);
//             setFilteredData(newFilteredData);

//             resetState();
//           } else {
//             throw new Error("Delete failed");
//           }
//         } catch (error) {
//           Swal.fire("Error", "Failed to delete user", "error");
//         } finally {
//           setLoading(false);
//         }
//       }
//     });
//   };

//   // ================= SEARCH =================
//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchValue(value);
//     if (!value.trim()) {
//       setFilteredData(userdata);
//       return;
//     }
//     const filtered = userdata.filter(
//       (record) =>
//         record.name?.toLowerCase().includes(value) ||
//         record.email?.toLowerCase().includes(value) ||
//         record.mobile?.toLowerCase().includes(value)
//     );
//     setFilteredData(filtered);
//   };

//   // ================= TABLE COLUMNS =================
//   const columns = [
//     {
//       title: "Users",
//       dataIndex: "name",
//       render: (text, record) => <Link onClick={() => setUser(record)}>{text}</Link>,
//     },
//     { title: "User Type", dataIndex: "type" },
//     { title: "Email", dataIndex: "email" },
//     { title: "Phone", dataIndex: "mobile" },
//     { title: "Status", dataIndex: "status" },
//     { title: "Course", dataIndex: "course" },
//     {
//       title: "Actions",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: "6px" }}>
//           <button
//             style={{
//               padding: "3px 8px",
//               fontSize: "11px",
//               borderRadius: "4px",
//               border: "none",
//               backgroundColor: "#000",
//               color: "#fff",
//               cursor: "pointer",
//             }}
//             onClick={() => setUser(record)}
//           >
//             Edit
//           </button>
//           <button
//             style={{
//               padding: "3px 8px",
//               fontSize: "11px",
//               borderRadius: "4px",
//               border: "none",
//               backgroundColor: "#dc2626",
//               color: "#fff",
//               cursor: "pointer",
//             }}
//             onClick={() => deleteUser(record)}
//           >
//             Delete
//           </button>
//         </div>
//       ),
//     },
//   ];

  
//   return (
//     <>
//       <Header />

//       {loading ? (
//         <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
//           <ClassicSpinner size={50} color="black" loading={loading} />
//         </div>
//       ) : (
//         <div className="section-padding">
//           <div className="container grid grid-cols-12 gap-6">
//             <div className="col-span-5">
//               <div className="mini-title">
//                 User Management
//                 <div
//                   className="small-btn ml-4"
//                   onClick={() => navigate("/codomo/admin/createnewuser")}
//                 >
//                   New User
//                 </div>
//               </div>

//               <div className="bg-white shadow-box7 p-8 rounded-md mt-6">
//                 <Input
//                   placeholder="Search by Name, Phone or Email"
//                   value={searchValue}
//                   onChange={handleSearch}
//                   style={{ marginBottom: 16 }}
//                 />

//                 {selecteduser && (
//                   <>
//                     <hr />
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       value={userName}
//                       onChange={(e) => setUserName(e.target.value)}
//                     />
//                     <select
//                       className="from-control mt-4"
//                       value={userType}
//                       onChange={(e) => setUserType(e.target.value)}
//                     >
//                       <option value="student">Student</option>
//                       <option value="mentor">Mentor</option>
//                       <option value="admin">Admin</option>
//                     </select>
//                     <input
//                       type="email"
//                       className="from-control mt-4"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       value={phone}
//                       onChange={(e) => setPhone(e.target.value)}
//                     />
//                     <select
//                       className="from-control mt-4"
//                       value={status}
//                       onChange={(e) => setStatus(e.target.value)}
//                     >
//                       <option value="active">Active</option>
//                       <option value="inactive">Inactive</option>
//                       <option value="expired">Expired</option>
//                     </select>
//                     <input
//                       type="text"
//                       className="from-control mt-4"
//                       placeholder="No Course Assigned"
//                       value={course}
//                       onChange={(e) => setCourse(e.target.value)}
//                     />
//                     <div className="flex gap-2 mt-4">
//                       <div>
//                         <button
//                           className="btn btn-black"
//                           onClick={UpdateUserDataToCloud}
//                         >
//                           Update User
//                         </button>
//                       </div>
//                       <div style={{ paddingLeft: "10px" }}>
//                         <button
//                           className="btn btn-red ms-2"
//                           onClick={resetState}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>

//             <div className="col-span-12">
//               <div className="bg-white shadow-box7 p-8 rounded-md">
//                 <div style={{ marginBottom: "10px" }}>
//                   User Count: {filteredData.length}
//                 </div>
//                 <Table
//                   columns={columns}
//                   dataSource={filteredData}
//                   rowKey={(record) => record.id}
//                   pagination={filteredData.length > 9}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default UserManagement;

































import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../Header";
import { Table, Input } from "antd";
import { FetchUserDetailsForAdmin, UpdateUserDetails } from "../../api/aws-api";
import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
import { ClassicSpinner } from "react-spinners-kit";
import Swal from "sweetalert2";

const UserManagement = () => {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [userdata, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selecteduser, setSelectedUser] = useState(null);

  const [userName, setUserName] = useState("");
  const [userType, setUserType] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState("");
  const [course, setCourse] = useState("");
  const [meetLink, setMeetLink] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchdata();
  }, []);

  // ================= SweetAlert styles =================
  const swalStyles = `
.swal2-popup { font-size: 16px !important; }
.swal2-title { font-weight: 600 !important; }
.swal2-confirm { background-color: #000 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
.swal2-cancel { background-color: #dc2626 !important; color: #fff !important; padding: 8px 18px !important; border-radius: 5px !important; font-size: 14px !important; }
`;
  if (typeof document !== "undefined") {
    const style = document.createElement("style");
    style.innerHTML = swalStyles;
    document.head.appendChild(style);
  }

  // ================= FETCH USERS =================
  const fetchdata = async () => {
    try {
      setLoading(true);
      const response = await ConstructorEventGet(FetchUserDetailsForAdmin);
      let users = [];
      if (response?.body) {
        let parsed = response.body;
        if (typeof parsed === "string") parsed = JSON.parse(parsed);
        if (typeof parsed === "string") parsed = JSON.parse(parsed);
        users = parsed;
      } else if (Array.isArray(response)) {
        users = response;
      }
      setUserData(users);
      setFilteredData(users);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch users", "error");
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setSelectedUser(null);
    setUserName("");
    setUserType("");
    setEmail("");
    setPhone("");
    setStatus("");
    setCourse("");
    setMeetLink("");
  };

  const setUser = (data) => {
    setSelectedUser(data);
    setUserName(data.name);
    setUserType(data.type);
    setEmail(data.email);
    setPhone(data.mobile);
    setStatus(data.status);
    // "No Course Assigned" is a display placeholder from the backend, not
    // a real course name — don't let it round-trip back into the field.
    setCourse(data.course && data.course !== "No Course Assigned" ? data.course : "");
    setMeetLink(data.meet_link || "");
  };

  // ================= UPDATE USER =================
  const UpdateUserDataToCloud = async () => {
    if (!selecteduser) return;
    try {
      setLoading(true);
      const params = {
        action: "update",
        user_id: selecteduser.id,
        user_type: userType,
        user_mobile: phone,
        user_status: status,
        user_name: userName,
        user_email: email,
        // Comma-separated course names, e.g. "Junior Innovators, Foundation"
        // Backend turns this into the list-of-course-objects shape it stores.
        user_course: course,
        // Static per-mentor Google Meet link. Only meaningful for
        // userType === "mentor", but harmless to send blank otherwise —
        // the Lambda just writes whatever string it's given.
        user_meet_link: meetLink,
      };

      const response = await ConstructorEventPost(UpdateUserDetails, params);

      // The backend returns statusCode 409 with {error: "duplicate", message}
      // when the email/mobile already belongs to a different account.
      if (response?.statusCode === 409) {
        const conflict = response?.body ? JSON.parse(response.body) : null;
        Swal.fire("Can't update user", conflict?.message || "This email or mobile number is already in use.", "warning");
        setLoading(false);
        return;
      }

      const result =
        typeof response === "string"
          ? response
          : response?.body
          ? JSON.parse(response.body)
          : null;
      if (result === "updated") {
        Swal.fire({
          title: "Success!",
          text: "User updated successfully",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#000"
        });

        // ===== Update the user in both userdata and filteredData =====
        const updatedUser = {
          ...selecteduser,
          name: userName,
          type: userType,
          email,
          mobile: phone,
          status,
          course: course.trim() ? course : "No Course Assigned",
          meet_link: meetLink,
        };

        const newUserData = userdata.map((u) =>
          u.id === updatedUser.id ? updatedUser : u
        );
        setUserData(newUserData);

        const newFilteredData = filteredData.map((u) =>
          u.id === updatedUser.id ? updatedUser : u
        );
        setFilteredData(newFilteredData);

        resetState();
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update user", "error");
    } finally {
      setLoading(false);
    }
  };

  // ================= DELETE USER =================
  const deleteUser = async (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Delete user ${record.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const params = { action: "delete", user_id: record.id };
          const response = await ConstructorEventPost(UpdateUserDetails, params);
          const resultData =
            typeof response === "string"
              ? response
              : response?.body
              ? JSON.parse(response.body)
              : null;
          if (resultData === "deleted") {
            Swal.fire("Deleted!", "User removed successfully.", "success");

            // Remove from both arrays
            const newUserData = userdata.filter((u) => u.id !== record.id);
            setUserData(newUserData);
            const newFilteredData = filteredData.filter((u) => u.id !== record.id);
            setFilteredData(newFilteredData);

            resetState();
          } else {
            throw new Error("Delete failed");
          }
        } catch (error) {
          Swal.fire("Error", "Failed to delete user", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // ================= SEARCH =================
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchValue(value);
    if (!value.trim()) {
      setFilteredData(userdata);
      return;
    }
    const filtered = userdata.filter(
      (record) =>
        record.name?.toLowerCase().includes(value) ||
        record.email?.toLowerCase().includes(value) ||
        record.mobile?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  // ================= TABLE COLUMNS =================
  const columns = [
    {
      title: "Users",
      dataIndex: "name",
      render: (text, record) => <Link onClick={() => setUser(record)}>{text}</Link>,
    },
    { title: "User Type", dataIndex: "type" },
    { title: "Email", dataIndex: "email" },
    { title: "Phone", dataIndex: "mobile" },
    { title: "Status", dataIndex: "status" },
    { title: "Course", dataIndex: "course" },
    {
      title: "Actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "6px" }}>
          <button
            style={{
              padding: "3px 8px",
              fontSize: "11px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#000",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={() => setUser(record)}
          >
            Edit
          </button>
          <button
            style={{
              padding: "3px 8px",
              fontSize: "11px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#dc2626",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={() => deleteUser(record)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Header />

      {loading ? (
        <div style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <ClassicSpinner size={50} color="black" loading={loading} />
        </div>
      ) : (
        <div className="section-padding">
          <div className="container grid grid-cols-12 gap-6">
            <div className="col-span-5">
              <div className="mini-title">
                User Management
                <div
                  className="small-btn ml-4"
                  onClick={() => navigate("/codomo/admin/createnewuser")}
                >
                  New User
                </div>
              </div>

              <div className="bg-white shadow-box7 p-8 rounded-md mt-6">
                <Input
                  placeholder="Search by Name, Phone or Email"
                  value={searchValue}
                  onChange={handleSearch}
                  style={{ marginBottom: 16 }}
                />

                {selecteduser && (
                  <>
                    <hr />
                    <input
                      type="text"
                      className="from-control mt-4"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                    <select
                      className="from-control mt-4"
                      value={userType}
                      onChange={(e) => setUserType(e.target.value)}
                    >
                      <option value="student">Student</option>
                      <option value="mentor">Mentor</option>
                      <option value="admin">Admin</option>
                    </select>
                    <input
                      type="email"
                      className="from-control mt-4"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                      type="text"
                      className="from-control mt-4"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    <select
                      className="from-control mt-4"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="expired">Expired</option>
                    </select>
                    <input
                      type="text"
                      className="from-control mt-4"
                      placeholder="No Course Assigned"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    />

                    {/* NEW — only meaningful for mentors, so only shown for them */}
                    {userType === "mentor" && (
                      <input
                        type="text"
                        className="from-control mt-4"
                        placeholder="Google Meet link (e.g. https://meet.google.com/xxx-xxxx-xxx)"
                        value={meetLink}
                        onChange={(e) => setMeetLink(e.target.value)}
                      />
                    )}

                    <div className="flex gap-2 mt-4">
                      <div>
                        <button
                          className="btn btn-black"
                          onClick={UpdateUserDataToCloud}
                        >
                          Update User
                        </button>
                      </div>
                      <div style={{ paddingLeft: "10px" }}>
                        <button
                          className="btn btn-red ms-2"
                          onClick={resetState}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="col-span-12">
              <div className="bg-white shadow-box7 p-8 rounded-md">
                <div style={{ marginBottom: "10px" }}>
                  User Count: {filteredData.length}
                </div>
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record) => record.id}
                  pagination={filteredData.length > 9}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserManagement;